export default class DisputeContactDetails {
  /**
   * @param {Object} param0
   * @param {number} param0.id - contact ID.
   * @param {string} param0.name - contact name.
   * @param {string} param0.phone1 - Primary phone number.
   * @param {string} param0.phone2 - Secondary phone number.
   * @param {string} param0.phone3 - Tertiary phone number.
   * @param {string} param0.email - Email address.
   * @param {string|null} param0.position - Position title (nullable).
   */
  constructor({ id, name, phone1, phone2, phone3, email, position }) {
    /** @type {number} */
    this.id = id
    /** @type {string} */
    this.name = name
    /** @type {string} */
    this.phone1 = phone1
    /** @type {string} */
    this.phone2 = phone2
    /** @type {string} */
    this.phone3 = phone3
    /** @type {string} */
    this.email = email
    /** @type {string|null} */
    this.position = position
  }
}
